import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw9011Handlers = [
  // KYMW9011関連会社一覧
  http.post(
    PlessService.SERVICE.passwordReset.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(passwordReset);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),
];

const passwordReset = {
  status: "ok",
  message: "処理終了",
}